/**
 * Labstep
 *
 * @module components/Log/Filter/ObjectClass/Active
 * @desc Filter Log Object Class Active
 */

import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { LogFilterObjectClassActiveProps } from './types';
import { getNameAndIcon } from './utils';

export const LogFilterObjectClassActive: React.FC<
  LogFilterObjectClassActiveProps
> = ({ clearParams, searchParams }) => {
  if (!('object_class' in searchParams)) {
    return null;
  }

  return (
    <RemoveLabel
      {...getNameAndIcon(searchParams.object_class as string)}
      onRemoveClick={
        clearParams && ((): void => clearParams(['object_class']))
      }
    />
  );
};
